// PANTALLA 6 — Estilo de Entrenamiento / Feedback
// Documento Maestro v2.2, §6 [REDISEÑADA POR COMPLETO en v2.2]
//
// ⚠️ SUSTITUYE a la antigua Screen6_Logistica.jsx, que preguntaba tiempo diario
//    (`time_commitment`) y estilo de aprendizaje (`learning_style`). v2.2
//    eliminó ambas: la de tiempo era redundante con el nivel de intensidad que
//    ya se eligió en la Pantalla 2.
//
// El valor elegido aquí alimenta directamente el System Prompt de Spacy a
// través de la variable `feedback_style`. No es copy decorativo: define cómo
// va a corregir la IA durante el entrenamiento.
import { useState } from 'react';
import OptionCards, { MicroReaction } from './OptionCards';
import { SCREEN6_HEADLINE, FEEDBACK_STYLES } from './onboardingContent';
import { etiquetaDePaso } from './pasos';

export default function Screen6_EstiloEntrenamiento({ feedbackStyle, onAnswer, onNext }) {
  const [selected, setSelected] = useState(feedbackStyle ?? null);

  const chosen = FEEDBACK_STYLES.find((f) => f.value === selected);

  const handleSelect = (v) => {
    setSelected(v);
    onAnswer({ feedback_style: v });
  };

  return (
    <div className="ob-screen">
      <p className="ob-eyebrow">{etiquetaDePaso(8)}</p>
      <h1 className="ob-headline">
        <span className="ob-headline-linea">{SCREEN6_HEADLINE.linea}</span>
        <span className="ob-bloque">{SCREEN6_HEADLINE.bloque}</span>
      </h1>

      <OptionCards options={FEEDBACK_STYLES} selected={selected} onSelect={handleSelect} />

      <MicroReaction text={chosen?.reaction} />

      {chosen && (
        <div className="ob-actions">
          <button type="button" className="ob-btn" onClick={onNext}>
            Ver mi plan de entrenamiento →
          </button>
        </div>
      )}
    </div>
  );
}
